import PrimaryMenuItem from '../model/PrimaryMenuItem';

const admin = new PrimaryMenuItem('Admin', 'settings', () => import('@/pages/Features/Admin.vue'));

export default admin;
